 <template>
 <v-row class="ma-2">
      <v-col
        cols=6
        sm=3
        xs=6
        class="d-flex justify-start"
      >
      <v-icon>mdi-swap-horizontal</v-icon> {{ transactions }}
      </v-col>
      <v-col
        cols=8
        sm=6
        xs=12
        class="d-flex justify-center"
      >
      <span><v-icon color="green">mdi-arrow-right-thin</v-icon>
        {{ $tocurr(debit) }}</span>
      <span><v-icon color="red">mdi-arrow-left-thin</v-icon>
      {{ $tocurr(charge) }}
      </span>
      </v-col>
      <v-col
        cols=6
        sm=3
        xs=6
        class="d-flex justify-end"
      >
      Υπόλοιπο: {{ $tocurr(balance) }}
      </v-col>
      </v-row>
</template>


<script>

export default {
  props: {
    transactions: { required: true, type: Number },
    charge: { required: true, type: Number },
    debit: { required: true, type: Number },
    balance: { required: true, type: Number  },
  },
}

</script>
